import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import cn from 'classnames';
import Icon from 'src/components/HTKit/Icon/Icon';
import HT_INFO from 'src/constants/hellotech';
import styles from './styles.scss';

const ProductPriceGuarantee = ({ className }) => {
  const {
    siteLinks: { priceGuarantee },
  } = HT_INFO;

  return (
    <div className={className}>
      <Link to={{ pathname: priceGuarantee.url }} className={styles.guaranteeLink} target="_blank">
        <p className={cn('p2 text-weight-med successGreen500', styles.guaranteeWrapper)}>
          <Icon name="ht-money" className={cn('marginRight-tiny', styles.priceGuaranteeIcon)} />
          <span className={styles.linkText}>Price Match Guarantee</span>
        </p>
      </Link>
    </div>
  );
};

ProductPriceGuarantee.propTypes = {
  className: PropTypes.string,
};

export default ProductPriceGuarantee;
